
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Card from 'vux/src/components/card/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
name: "Recommand",
data() {
return {
radioList: [],
slider: [],
songList: [],
msg: "Recommand"
};
},
created: async function() {
this.$store.commit("loadingCtrl",true);
let res = await this.$store.dispatch("getRecommands");
let _data = res.data.data;
this.radioList = _data.radioList;
this.slider = _data.slider;
this.songList = _data.songList;
this.$store.commit("loadingCtrl",false);
},
methods: {
getRadioList: async function(item) {
try {
this.$store.commit("loadingCtrl",true);
let res = await this.$store.dispatch("getRadioList", item.radioid);
console.log(res.data);
this.$store.commit("notify",{ text: "获取数据成功" });
} catch (error) {
this.$store.commit("notify",{ text: "获取数据失败" });
}
this.$store.commit("loadingCtrl",false);
},
getAlbum(item) {
this.$router.push({ name: "cd", params: { id: item.id } });
},
...mapMutations([ 'loadingCtrl','notify' ])
},
components: { Flexbox, FlexboxItem, Card, XImg, Swiper, SwiperItem, Group, CellBox }
};



// WEBPACK FOOTER //
// ./src/components/Recommand.vue